export let SearchFilterType = /*#__PURE__*/function (SearchFilterType) {
  SearchFilterType["MultiSelectFilter"] = "MultiSelectFilter";
  SearchFilterType["DateRangeFilter"] = "DateRangeFilter";
  SearchFilterType["RadioFilter"] = "RadioFilter";
  SearchFilterType["DateRangeWithPresets"] = "DateRangeWithPresets";
  SearchFilterType["CustomFilter"] = "CustomFilter";
  return SearchFilterType;
}({});
export let DateRange = /*#__PURE__*/function (DateRange) {
  DateRange["Last12Months"] = "last12Months";
  DateRange["CurrentMonth"] = "currentMonth";
  DateRange["CurrentQuarter"] = "currentQuarter";
  DateRange["CurrentYear"] = "currentYear";
  DateRange["AllTime"] = "allTime";
  DateRange["Custom"] = "Custom";
  return DateRange;
}({});